import type { ChildRiskRating } from '@gcv/shared';

export interface RollupCoverage {
  assessedCount: number;
  childCount: number;
  missingCount: number;
  /** Some, but not all, of the parent's children fed the roll-up. */
  isPartial: boolean;
  isEmpty: boolean;
  /** Latest `last_assessed_on` among the contributing children. */
  lastUpdatedOn?: string;
}

/** How much of a parent's roll-up is covered. `contributes` is the API's own verdict. */
export const getRollupCoverage = (children?: ChildRiskRating[]): RollupCoverage => {
  const all = children ?? [];
  const contributing = all.filter((child) => child.contributes);

  return {
    assessedCount: contributing.length,
    childCount: all.length,
    missingCount: all.length - contributing.length,
    isPartial: contributing.length > 0 && contributing.length < all.length,
    isEmpty: contributing.length === 0,
    lastUpdatedOn: contributing
      .map((child) => child.last_assessed_on)
      .filter((date): date is string => !!date)
      .sort()
      .pop()
  };
};
